export { PostHogProvider, usePostHogRuntime } from "./PostHogProvider";
export { useFeatureFlag, useFeatureFlagVariant } from "./useFeatureFlag";
export { initPostHog, getPostHogRuntime } from "./client";
export type { PostHogRuntime } from "./client";
export { track, bindTrackToCurrentUser, ANALYTICS_EVENTS } from "./events";
export type { FranklinEvent } from "./events";

/** Canonical names for feature flags the app reads. Keep in sync with PostHog project. */
export const FEATURE_FLAGS = {
  /** Gates the entire PM module (Issues / Tasks / Protocols / Brief). Default: ON. */
  PM_MODULE_ENABLED: "PM-Module",
} as const;
